import React from "react";
import { hot } from 'react-hot-loader';
import { useDispatch, useSelector } from "react-redux";

import { loadMunicipalities, loadOptional,loadPrefs, setPrefs } from "../../../slice";

const copyObject = (data) => {
  return Object.assign({}, JSON.parse(JSON.stringify(data)));
}

const getAreaId = (setting) => {
  if (setting.municipality !== "") {
    return setting.municipality;
  }

  if (setting.pref !== "") {
    return setting.pref.substring(0, 2);
  }

  return "";
}

const PrefMunicipalitySelect = ({ setting, setSetting }) => {
  const dispatch = useDispatch();
  const prefs = useSelector((state) => state.manual.prefs);
  const municipalities = useSelector((state) => state.manual.municipalities);

  const pref = setting.pref;
  const municipality = setting.municipality;

  if (prefs === null) {
    dispatch(setPrefs('loading'));

    setTimeout(() => {
      dispatch(loadPrefs());
    }, 100);

    return null;
  } else if (prefs === 'loading') {
    return null;
  }

  const pref_options = [];
  pref_options.push(<option key={0} value="">--</option>);
  prefs.forEach(data => {
    pref_options.push(<option key={data.code} value={data.code}>{data.name}</option>);
  });

  let allStr = '--'
  if (pref !== "") {
    allStr = "全体"
  }

  const municipality_options = [];
  municipality_options.push(<option key={0} value="">{allStr}</option>);
  if (municipalities !== null) {
    municipalities.forEach(data => {
      municipality_options.push(<option key={data.code} value={data.code}>{data.name}</option>);
    })
  }

  return (
    <div className="select">
      <form>
        <select name="pref" value={pref} onChange={(e) => {
          const newSetting = copyObject(setting);
          newSetting.pref = e.target.value;
          newSetting.municipality = "";
          setSetting(newSetting);
          dispatch(loadMunicipalities(newSetting.pref));
          dispatch(loadOptional(getAreaId(newSetting)));
        }}>
          {pref_options}
        </select>

        &nbsp;

        <select id="kiso" name="kiso" value={municipality} onChange={(e) => {
          const newSetting = copyObject(setting);
          newSetting.municipality = e.target.value;
          setSetting(newSetting);
          dispatch(loadOptional(getAreaId(newSetting)));
        }}>
          {municipality_options}
        </select>
      </form>
    </div>
  );
}

export default hot(module)(PrefMunicipalitySelect);
